<template>
    <portal>
        <transition name="zoom-out">
            <div tabindex="-1" :class="`redui-modal ${classes}`" v-if="value">
                <div class="modal-mask"></div>
                <div :style="`max-width: ${maxWidth}px`">
                    <div class="modal-container">
                        <header class="modal-header" v-if="showHeader">
                            <slot name="header"></slot>
                        </header>
                        <section class="modal-body">
                            <slot name="content"></slot>
                            <slot></slot>
                        </section>
                        <footer class="modal-footer" v-if="showFooter">
                            <slot name="footer">
                                <button class="button is-cancel" @click="$emit('input', false)">
                                    {{ $t('close') }}
                                </button>
                            </slot>
                        </footer>
                    </div>
                </div>
            </div>
        </transition>
    </portal>
</template>

<script>
import { Portal } from '@linusborg/vue-simple-portal';

export default {
    name: 'Modal',
    components: { Portal },
    props: {
        value: { type: Boolean, default: false, required: true },
        showFooter: { type: Boolean, default: true },
        showHeader: { type: Boolean, default: true },
        maxWidth: { type: Number, default: 960 },
        classes: { type: String },
    },
    data() {
        return {};
    },
    i18n: {
        messages: {
            en: {
                close: 'Close',
            },
            fr: {
                close: 'Fermer',
            },
            nl: {
                close: 'Sluiten',
            },
        },
    },
};
</script>

<style lang="scss">
.modal-mask {
    bottom: 0;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;

    transition: opacity 0.3s ease;
    background-color: #172b4d;
    opacity: 0.3;
    z-index: 9;
}

.redui-modal {
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    overflow: hidden;
    position: fixed;
    z-index: 99000;
}
html body > .daterangepicker,
html body > .control.datepicker {
    z-index: 99999 !important;
}

.modal-container {
    margin: 0;
    position: relative;
    display: flex;
    flex-direction: column;
    max-height: calc(100vh - 40px);

    box-shadow: 0px 0px 15px rgba(23, 23, 23, 0.25);
    border-radius: 15px;
    overflow: auto;
    background-color: white;
    width: auto;
    min-width: 640px;
    z-index: 11;
}

header.modal-header {
    align-items: center;
    display: flex;
    flex-shrink: 0;
    justify-content: flex-start;
    padding: 20px;
    padding-top: 20px;
    padding-bottom: 20px;
    position: relative;
    border-radius: 15px;
    background-color: #fff;
    border: 0;
    padding-top: 15px;
    padding-bottom: 0;

    .modal-title {
        font-size: 2.4rem;
        line-height: 24px;
        font-weight: 500;

        word-break: break-word;
    }
}

footer.modal-footer {
    padding: 20px;
}

.modal-body {
    background-color: #ffffff;
    flex-grow: 1;
    flex-shrink: 1;
    padding: 20px;
    border-radius: 15px;
    overflow: visible;
    text-align: left;
}

// Zoom Out
.zoom-out-enter-active,
.zoom-out-leave-active {
    transition: opacity 0.4s ease;
    .modal-container,
    .modal-container {
        transition: transform 0.4s ease;
    }
}
.zoom-out-enter,
.zoom-out-leave-active {
    opacity: 0;
    .modal-container,
    .modal-container {
        transform: scale(1.05);
    }
}

//Fix dropdown overflow
.redui-modal .modal-body {
    .dropdown .dropdown-menu {
        position: fixed;
        left: auto;
        top: auto;
        right: auto;
        bottom: auto;
        margin-top: 35px; //size of button
    }
}
</style>
